import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  loadThemeColors(theme: any) {
    return new Promise<void>((resolve) => {
      let colors = {};
      if (theme == 'classic') {
        colors = {
          '--color-brand-01-lightest': '#E3EEFB',
          '--color-brand-01-lighter': '#AFD3FA',
          '--color-brand-01-light': '#3DADFA',
          '--color-brand-01-dark': '#00659A',
          '--color-brand-01-darker': '#004064',
          '--color-brand-01-darkest': '#051F31',
          '--color-brand-01-base': '#0079B8',
          '--color-brand-02-base': '#0079B8',
          '--color-brand-03-base': '#0079B8',
          '--color-neutral-light-00': '#fbfbfb',
          '--color-neutral-light-05': '#EEEEEE',
          '--color-neutral-light-10': '#D9D9D9',
          '--color-neutral-light-20': '#C1C1C1',
          '--color-neutral-light-30': '#A1A1A1',
          '--color-neutral-dark-70': '#3B3B3B',
          '--color-neutral-dark-80': '#2B2B2B',
          '--color-neutral-dark-90': '#202020',
          '--color-neutral-dark-95': '#1C1C1C',
          '--color-neutral-mid-40': '#9da7a9',
          '--color-neutral-mid-60': '#6e7c7f',
          '--color-primary': '#0079B8',
          '--color-secondary': '#00659A',
          '--color-tertiary': '#0adbe3',
        };
      } else if (theme == 'sunset') {
        colors = {
          '--color-brand-01-lightest': '#FFEBEE',
          '--color-brand-01-lighter': '#EF9A9A',
          '--color-brand-01-light': '#EF5350',
          '--color-brand-01-dark': '#A5131A',
          '--color-brand-01-darker': '#5D0D11',
          '--color-brand-01-darkest': '#400A08',
          '--color-brand-01-base': '#c20c18',
          '--color-brand-02-base': '#c20c18',
          '--color-brand-03-base': '#c20c18',
          '--color-neutral-light-00': '#FFFFFF',
          '--color-neutral-light-05': '#EEEEEE',
          '--color-neutral-light-10': '#E5E5E5',
          '--color-neutral-light-20': '#CCCCCC',
          '--color-neutral-light-30': '#B2B2B2',
          '--color-neutral-dark-70': '#4D4D4D',
          '--color-neutral-dark-80': '#363636',
          '--color-neutral-dark-90': '#1A1A1A',
          '--color-neutral-dark-95': '#121212',
          '--color-neutral-mid-40': '#9da7a9',
          '--color-neutral-mid-60': '#6e7c7f',
          '--color-primary': '#c20c18',
          '--color-secondary': '#a5131a',
          '--color-tertiary': '#ef9a9a',
        };
      } /*else if (theme == 'dark') {
        colors = {
          '--color-brand-01-lightest': '#051F31',
          '--color-brand-01-lighter': '#004064',
          '--color-brand-01-light': '#00659A',
          '--color-brand-01-dark': '#3DADFA',
          '--color-brand-01-darker': '#AFD3FA',
          '--color-brand-01-darkest': '#E3EEFB',
          '--color-brand-01-base': '#0079B8',
          '--color-brand-02-base': '#0079B8',
          '--color-brand-03-base': '#0079B8',
          '--color-neutral-light-00': '#1C1C1C',
          '--color-neutral-light-05': '#202020',
          '--color-neutral-light-10': '#2B2B2B',
          '--color-neutral-light-20': '#3B3B3B',
          '--color-neutral-light-30': '#5A5A5A',
          '--color-neutral-dark-70': '#C1C1C1',
          '--color-neutral-dark-80': '#363636',
          '--color-neutral-dark-90': '#EEEEEE',
          '--color-neutral-dark-95': '#FBFBFB',
          '--color-neutral-mid-40': '#9da7a9',
          '--color-neutral-mid-60': '#6e7c7f',
          '--color-widget-color-default': '#EEEEEE',
          '--color-primary': '#0079B8',
          '--color-secondary': '#0079B8',
          '--color-tertiary': '#0079B8',
        };
      } else if (theme == 'dark-sunset') {
        colors = {
          '--color-brand-01-lightest': '#EF9A9A',
          '--color-brand-01-lighter': '#EF9A9A',
          '--color-brand-01-light': '#EF5350',
          '--color-brand-01-dark': '#A5131A',
          '--color-brand-01-darker': '#EEEEEE',
          '--color-brand-01-darkest': '#400A08',
          '--color-brand-01-base': '#C20C18',
          '--color-brand-02-base': '#C20C18',
          '--color-brand-03-base': '#C20C18',
          '--color-neutral-light-00': '#1C1C1C',
          '--color-neutral-light-05': '#202020',
          '--color-neutral-light-10': '#2B2B2B',
          '--color-neutral-light-20': '#3B3B3B',
          '--color-neutral-light-30': '#5A5A5A',
          '--color-neutral-dark-70': '#C1C1C1',
          '--color-neutral-dark-80': '#363636',
          '--color-neutral-dark-90': '#EEEEEE',
          '--color-neutral-dark-95': '#FBFBFB',
          '--color-neutral-mid-40': '#9da7a9',
          '--color-neutral-mid-60': '#6e7c7f',
          '--color-widget-color-default': '#EEEEEE',
          '--color-primary': '#C20C18',
          '--color-secondary': '#C20C18',
          '--color-tertiary': '#C20C18',
        };
      }*/

      this.setThemeColors(colors);
      resolve();
    });
  }

  private setThemeColors(colors: any) {
    for (const key in colors) {
      if (colors.hasOwnProperty(key)) {
        document.documentElement.style.setProperty(key, colors[key]);
      }
    }
  }
}
